// extracted by mini-css-extract-plugin
export default {"divider":"t73WZRFNCoAp4SidbeIH"};